import { gql } from "@apollo/client";

export const ADMIN_NEWSLETTER_BANNERS_QUERY = gql`
  query AdminNewsletterBanners {
    newsletterBanners {
      id
      image
      updatedAt
    }
  }
`;

export const CREATE_NEWSLETTER_BANNER_MUTATION = gql`
  mutation CreateNewsletterBanner($image: String!) {
    createNewsletterBanner(input: { image: $image }) {
      newsletterBanner {
        id
        image
        updatedAt
      }
      errors
    }
  }
`;

export const UPDATE_NEWSLETTER_BANNER_MUTATION = gql`
  mutation UpdateNewsletterBanner($id: ID!, $image: String!) {
    updateNewsletterBanner(input: { id: $id, image: $image }) {
      newsletterBanner {
        id
        image
        updatedAt
      }
      errors
    }
  }
`;

export const DELETE_NEWSLETTER_BANNER_MUTATION = gql`
  mutation DeleteNewsletterBanner($id: ID!) {
    deleteNewsletterBanner(input: { id: $id }) {
      success
      errors
    }
  }
`;

/** PUBLIC banner shown on subscribe page */
export const NEWSLETTER_BANNER_QUERY = gql`
  query NewsletterBanner {
    newsletterBanner {
      id
      image
      updatedAt
    }
  }
`;

/** subscribers keep same */
export const ADMIN_NEWSLETTER_SUBSCRIBERS_QUERY = gql`
  query AdminNewsletterSubscribers {
    newsletterSubscribers {
      id
      fullName
      email
      gender
      phone
      address
      createdAt
    }
  }
`;

export const CREATE_NEWSLETTER_SUBSCRIBER_MUTATION = gql`
  mutation CreateNewsletterSubscriber(
    $fullName: String!
    $email: String!
    $gender: String
    $phone: String
    $address: String
  ) {
    createNewsletterSubscriber(
      input: {
        fullName: $fullName
        email: $email
        gender: $gender
        phone: $phone
        address: $address
      }
    ) {
      subscriber {
        id
        fullName
        email
        gender
        phone
        address
        createdAt
      }
      errors
    }
  }
`;
